<form [formGroup]="formGroup">
  <div class="d-flex flex-column gap-4">
    <div class="form-grid">
      <div class="d-flex flex-column gap-1">
        <label class="form-input-label" for="firstName" i18n>First Name</label>
        <app-text-input
          controlId="firstName"
          formControlName="firstName"
          [error]="formSubmitted && formGroup.controls.firstName.invalid" />
        <app-form-error
          *ngIf="formSubmitted && formGroup.controls.firstName.invalid"
          [errors]="formGroup.controls.firstName.errors" />
      </div>

      <div class="d-flex flex-column gap-1">
        <label class="form-input-label" for="middleName" i18n>Middle Name</label>
        <app-text-input controlId="middleName" formControlName="middleName" />
        <small class="form-input-hint" i18n>Optional</small>
      </div>

      <div class="d-flex flex-column gap-1">
        <label class="form-input-label" for="lastName" i18n>Last Name</label>
        <app-text-input
          controlId="lastName"
          formControlName="lastName"
          [error]="formSubmitted && formGroup.controls.lastName.invalid" />
        <app-form-error
          *ngIf="formSubmitted && formGroup.controls.lastName.invalid"
          [errors]="formGroup.controls.lastName.errors" />
      </div>

      <div class="d-flex flex-column gap-1">
        <label class="form-input-label" for="preferredName" i18n>Preferred Name</label>
        <app-text-input controlId="preferredName" formControlName="preferredName" />
        <small class="form-input-hint" i18n>Optional</small>
      </div>
    </div>

    <hr class="mt-3" />

    <ng-content></ng-content>

    <div class="d-flex flex-column gap-1">
      <label class="form-input-label" for="file" i18n>Document</label>
      <app-file-upload-field
        controlId="file"
        formControlName="files"
        [accept]="acceptedFileTypes"
        [multiple]="allowMultipleFiles"
        [maxFileSizeInMb]="maxFileSizeInMb"
        [submitAttempted]="formSubmitted"
        [control]="formGroup.controls.files"
        [showThumbnail]="true">
        <div class="d-flex flex-column align-items-center gap-3" input-copy>
          <img
            src="assets/icons/grey/FileUpload.svg"
            alt="Upload File"
            i18n-alt
            height="24"
            width="24"
            [style.height.rem]="1.5"
            [style.width.rem]="1.5" />
          <app-file-uploader-text
            [disabled]="formGroup.controls.files.disabled"
            [descriptionText]="(uploadBody$ | async) ?? ''" />
        </div>
      </app-file-upload-field>
      <app-form-error
        *ngIf="formSubmitted && formGroup.controls.files.invalid"
        [errors]="formGroup.controls.files.errors"
        [customErrorMessages]="customErrorMessages.files" />
    </div>
  </div>
</form>
